import { forDocumentLoad } from 'waitasecond';

export async function activateGlobalCss() {
    await forDocumentLoad();

    const styleElement = document.createElement('style') as HTMLStyleElement;
    styleElement.innerHTML = `
    *[data-playground-role="dynamic"]{
        display: none;
    }
    `;
    document.body.appendChild(styleElement);
}
